export enum TooltipType {
  gray800 = 'gray800',
  gray200 = 'gray200',
  gray400 = 'gray400',
  primary = 'primary',
}
